(function () {
    'use strict';

    // Whether Auth0 could be configured is settled in the AngularJS config phase
    // (app.config.js), but has to be reported much later, on the login screen. A
    // provider is the one thing that spans both phases.
    //
    // Re-reading localStorage from the login screen would not do: the login route
    // resolve stores params it fetches (login.routing.js), so localStorage can look
    // healthy while the Auth0 client in memory was built without them. This records
    // what Auth0 was actually initialised with.
    angular
        .module('elogbooks')
        .provider('ssoConfig', SsoConfigProvider);

    SsoConfigProvider.$inject = [];

    function SsoConfigProvider() {
        var missingParams = [];

        // Called from the config phase with the keys the API should have supplied and didn't.
        this.setMissingParams = function (params) {
            missingParams = params || [];
        };

        this.$get = $get;
        $get.$inject = [];

        function $get() {
            return {
                isUsable: function () {
                    return missingParams.length === 0;
                },
                getMissingParams: function () {
                    return missingParams.slice();
                }
            };
        }
    }
})();
